/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeleteTenants = gql`
  mutation DeleteTenants($ids: [ID!]!) {
    deleteTenants(ids: $ids)
  }
`;
